import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Check, Backspace, Eye, Home, BuildingHospital, CaretRight, TrendingDown, Notebook, Scan, ClipboardCheck } from 'tabler-icons-react';
import btnHome from '../images/btnHomeIcon.png';
import idcheck from '../images/idcheck.gif';
import error from '../images/error.gif'
import notfound from '../images/notfound.gif'
import incorrect from '../images/exceed.gif'
import ReactCardFlip from 'react-card-flip';

const Generalregistration = () => {

    const [showInputs, setshowInput] = useState("none"); // input type
    const [showInfoBox, setshowInfoBox] = useState("none");// information box 
    const [showcantFindBox, setshowcantFindBox] = useState("none"); // cannot find detaits box
    const [showincorrectBox, setshowincorrectBox] = useState("none"); // incorrect ID box
    const [showblackListBox, setshowblackListBox] = useState("none"); // black listed boxbox 
    const [showKeyboard, setshowKeyboard] = useState("none"); // Keyboard

    const fnshowInputs = () => {
        setshowInput("block");
    };

    const fnhideInputs = () => {
        setshowInput("none");
    }

    const fnShowInfoBox = () => {
        setshowInfoBox("block"); //*
        setshowcantFindBox("none");
        setshowincorrectBox("none");
        setshowblackListBox("none");
    }

    const fnShowCantBox = () => {
        setshowInfoBox("none");
        setshowcantFindBox("block"); //*
        setshowincorrectBox("none");
        setshowblackListBox("none");
    }

    const fnShowIncoBox = () => {
        setshowInfoBox("none");
        setshowcantFindBox("none");
        setshowincorrectBox("block"); //*
        setshowblackListBox("none");
    }

    const fnShowBlacBox = () => {
        setshowInfoBox("none");
        setshowcantFindBox("none");
        setshowincorrectBox("none");
        setshowblackListBox("block"); //*
    }

    const fnResetPage = () => {
        setshowInput("none");
        setshowInfoBox("none");
        setshowcantFindBox("none");
        setshowincorrectBox("none");
        setshowblackListBox("none");
    }

    const fnShowKeyboard = () => {
        setshowKeyboard("block");
    }

    const fnHideKeyboard = () => {
        setshowKeyboard("none");
    }


    useEffect(() => {


    }, []);
    return (
        <div className="topicSection">

            {/* HOME BUTTON SECTION */}
            <div className="btnHomeSection bounce-in-fwd10">
                <button type="button" className="btnCircle" id="idBtnHome">
                    <img src={btnHome} alt="Date" height="50" width="50" /><br />
                    HOME
                </button>
            </div>

            <div className="headerSub">
                <div className="headerSubTitle scale-in-center">
                    <p>
                        PLEASE SCAN OR MANUALLY ENTER YOUR ID
                    </p>
                </div>
            </div>

            <div className="headerName">
                <div className="headerTitle slide-in-top">
                    <div className="iconRegister"></div>
                    <div className="iconNameTitle">REGISTRATION</div>
                </div>
            </div>


            {/* MAIN CONTENT SECTION */}
            <div className="contentPage">

                {/* BREADCRUMBS */}
                <div className="breadcrumbs">
                    <ul>
                        <li className="fcolorGreen fade-in-left2"><Home size={50} strokeWidth={2} color={'green'} /> <span className="crumHome">HOME </span>
                            <TrendingDown size={25} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorGreen fade-in-left3"><BuildingHospital size={40} strokeWidth={2} color={'green'} />
                            <b><i> Step 1</i></b>
                            <br />
                            OPTION <CaretRight size={40} strokeWidth={2} color={'green'} />
                        </li>
                        <li className="fcolorRed fade-in-left4"><Notebook size={40} strokeWidth={2} color={'red'} />
                            <b><i> Step 2</i></b> <br />
                            REGISTRATION <CaretRight size={40} strokeWidth={2} color={'red'} />
                        </li>
                        {/* <li className="fcolorGray fade-in-left5"><List size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 3</i></b> <br />
                            SUMMARY <CaretRight size={40} strokeWidth={2} color={'gray'} />
                        </li> */}
                        <li className="fcolorGray fade-in-left6"><ClipboardCheck size={40} strokeWidth={2} color={'gray'} />
                            <b><i> Step 3</i></b> <br />
                            COMPLETE

                            {/* For White space */}
                            <CaretRight size={40} strokeWidth={2} color={'transparent'} />
                        </li>
                    </ul>
                </div>



                {/* ==========BUTTON FEAURES========== */}
                <div className="triggerSwtich">
                    FOR DEMO ONLY:
                    <Button className="btn-sm btnSpacing btn-outline-light" onClick={() => fnshowInputs()}>
                        Show Other Input
                    </Button>
                    <Button className="btn-sm btnSpacing btn-outline-light" onClick={() => fnhideInputs()}>
                        Hide Other Input
                    </Button>

                    {/* MEDIA */}
                    {/* <Button className="btn-sm btnSpacing">
                        Scan Box
                    </Button> */}

                    <Button className="btn-sm btnSpacing btn-outline-light" onClick={() => fnShowInfoBox()}>
                        Show Info Record
                    </Button>

                    <Button className="btn-sm btnSpacing btn-outline-light" onClick={() => fnShowCantBox()}>
                        Show Cannot Found
                    </Button>

                    <Button className="btn-sm btnSpacing btn-outline-light" onClick={() => fnShowIncoBox()}>
                        Show Incorrect Format
                    </Button>

                    <Button className="btn-sm btnSpacing btn-outline-light" onClick={() => fnShowBlacBox()}>
                        Show Black listed
                    </Button>

                    <Button className="btn-sm btnSpacing btn-outline-light" onClick={() => fnResetPage()}>
                        RESET PAGE
                    </Button>

                    <Button className="btn-sm btnSpacing btn-outline-light" onClick={() => fnShowKeyboard()}>
                        Show Keyboard
                    </Button>
                </div>




                {/* BOX 1 - show media*/}
                <div className="iconSection3 flip-in-ver-right" id="idMediaBox">
                    <span>MEDIA</span>
                </div>



                {/* BOX 2 - show information*/}
                <div className="informationBox flip-in-ver-right" id="idinfoBox" style={{ display: showInfoBox }}>
                    <div className="infoContent">
                        <br />
                        <h2>INFORMATION</h2>
                        <div className="identPhoto">
                            {/* cardinfo */}
                            <img src={idcheck} alt="Identification Correct" height="130" />
                        </div>
                        <hr />
                        <div className="idenContent">
                            <ul>
                                <li><span>ID : GXXXXXX34R</span></li>
                                <li><span>Name : Micheal Jacobson</span></li>
                                <li><span>Mobile Number: 65 87200000</span></li>
                                <li><span>information aa: xxxxxx</span></li>
                                <li><span>information bb: xxxxxx</span></li>
                                <li><span>information cc: xxxxxx</span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                {/* RESCAN BUTTON  */}
                <div className="btnBoxPos3 flip-in-hor-top10" style={{ display: showInfoBox }}>
                    <button type="button" className="btnFBox">
                        <Scan size={35} strokeWidth={2} color={'white'} />
                        <br />
                        <p>RESCAN</p>
                    </button>
                </div>
                <div className="btnBoxProceedPos flip-in-hor-top12" style={{ display: showInfoBox }}>
                    <button type="button" className="btnPBox">
                        <Check size={35} strokeWidth={2} color={'white'} />
                        <br />
                        <p>PROCEED</p>
                    </button>
                </div>






                {/* BOX 3 - Record cannot be found*/}
                <div className="cannotFoundBox flip-in-ver-right" id="idcantfind" style={{ display: showcantFindBox }}>
                    <div className="boxContainer">
                        <div className="iconBoxSection">
                            <img src={notfound} alt="Cannot be found" height="300" />
                        </div>
                        <br />

                        <hr />
                        <div className="messageBoxSection">
                            <p>Record Cannot be found, Please approach our...</p>
                        </div>
                    </div>
                </div>
                {/* RESCAN BUTTON  */}
                <div className="btnBoxPos flip-in-hor-top10" style={{ display: showcantFindBox }}>
                    <button type="button" className="btnFBox">
                        <Scan size={35} strokeWidth={2} color={'white'} />
                        <br />
                        <p>RESCAN</p>
                    </button>
                </div>






                {/* BOX 4 - Incorrect format*/}
                <div className="incorrectFormatBox flip-in-ver-right" id="idincorrect" style={{ display: showincorrectBox }}>
                    <div className="boxContainer">
                        <div className="iconBoxSection">
                            <img src={incorrect} alt="Incorrect Format" height="300" />
                        </div>
                        <br />

                        <hr />
                        <div className="messageBoxSection">
                            <p>Incorrect format, Please approach our...</p>
                        </div>
                    </div>
                </div>
                {/* RESCAN BUTTON  */}
                <div className="btnBoxPos flip-in-hor-top10" style={{ display: showincorrectBox }}>
                    <button type="button" className="btnFBox">
                        <Scan size={35} strokeWidth={2} color={'white'} />
                        <br />
                        <p>RESCAN</p>
                    </button>
                </div>






                {/* BOX 5 - you are black listed */}
                <div className="blacklistBox flip-in-ver-right" id="idblacklist" style={{ display: showblackListBox }}>
                    <div className="boxContainer">
                        <div className="iconBoxSection">
                            <img src={error} alt="Black Listed" height="300" />
                        </div>
                        <br />

                        <hr />
                        <div className="messageBoxSection">
                            <p>The information provided is in our black listed list...</p>
                        </div>
                    </div>
                </div>
                {/* RESCAN BUTTON  */}
                <div className="btnBoxPos flip-in-hor-top10" style={{ display: showblackListBox }}>
                    <button type="button" className="btnFBox">
                        <Scan size={35} strokeWidth={2} color={'white'} />
                        <br />
                        <p>RESCAN</p>
                    </button>
                </div>





                {/* FORM SECTION  */}
                {/* INPUT DETAILS AFTER SCAN  */}
                <div className="formSection">
                    <br /><br /><br />
                    <h2 className="fade-in-tl5"><b>Title / Description here...</b></h2>
                    <br /><br />
                    <Form>
                        <br />
                        <Form.Group as={Row} controlId="formGroupVisitorId" className="fade-in-tl6">
                            <Form.Label column sm="4">Identification No. :</Form.Label>
                            <Col sm="8">
                                <Form.Control type="text" size="lg" placeholder="XXXX000111" maxlength="9" autoFocus />
                                <div className="input-group-prepend eyeBtnPos">
                                    <button className="btn btn-primary" type="button">
                                        <Eye size={24} strokeWidth={2} color={'white'} />
                                    </button>
                                </div>
                            </Col>
                        </Form.Group>
                        <br />
                        {/* <div id="idFullNameInput" style={{ display: this.useState.showInputs ?  "block" : "none"}}> */}

                        <div id="idFullNameInput" style={{ display: showInputs }}>
                            <Form.Group as={Row} controlId="formGroupVisitorName" className="fade-in-tl7">
                                <Form.Label column sm="4">Full Name :</Form.Label>
                                <Col sm="8">
                                    <Form.Control type="input" size="lg" placeholder="Full name" />
                                </Col>
                            </Form.Group>
                        </div>
                        <br />
                        <div id="idMobileInput" style={{ display: showInputs }}>
                            <Form.Group as={Row} controlId="formGroupVisitorMobile" className="fade-in-tl8">
                                <Form.Label column sm="4">Mobile No. :</Form.Label>
                                <Col sm="8">
                                    <Form.Control type="text" size="lg" placeholder="+65 XXXXXXXX" maxlength="8" />
                                </Col>
                            </Form.Group>
                        </div>
                    </Form>
                </div>


            </div>




            {/* ==========THE KEYBOARD========== */}
            <div className="popup" style={{ display: showKeyboard }} id="idPopKeyboard">

                {/* the specific input */}
                <div className="keyinvalue fade-in2">
                    <Form>
                        {/* <Form.Group as={Row} controlId="groupspecifInputPopUp" className="fade-in2">  */}
                        <Form.Group controlId="groupspecifInputPopUp" className="keyboardInputWd">
                            <Form.Label lg="4" className="fcolorWhite keyInputVal"> Identification No. :</Form.Label>
                            <Col lg="12">
                                <Form.Control type="input" size="lg" placeholder="" className="keyInputVal" autfocus />
                            </Col>
                            <div className="input-group-prepend eyeBtnPos2">
                                <button className="btn btn-primary" type="button">
                                    <Eye size={24} strokeWidth={2} color={'white'} />
                                </button>
                            </div>
                        </Form.Group>
                    </Form> 
                </div>


                {/* SHADE */}
                <div className="popupBoxCut fade-in1"></div>

                {/* Keyboard */}
                <div className="popupin slide-in-bottom3">
                    <ul>
                        <li><button type="button" alt="1" label="1" className="keyBtns"> 1 </button></li>
                        <li><button type="button" alt="2" label="2" className="keyBtns"> 2 </button></li>
                        <li><button type="button" alt="3" label="3" className="keyBtns"> 3 </button></li>
                        <li><button type="button" alt="4" label="4" className="keyBtns"> 4 </button></li>
                        <li><button type="button" alt="5" label="5" className="keyBtns"> 5 </button></li>
                        <li><button type="button" alt="6" label="6" className="keyBtns"> 6 </button></li>
                        <li><button type="button" alt="7" label="7" className="keyBtns"> 7 </button></li>
                        <li><button type="button" alt="8" label="8" className="keyBtns"> 8 </button></li>
                        <li><button type="button" alt="9" label="9" className="keyBtns"> 9 </button></li>
                        <li><button type="button" alt="0" label="0" className="keyBtns"> 0 </button></li>
                    </ul>
                    <ul>
                        <li><button type="button" alt="Q" label="Q" className="keyBtns"> Q </button></li>
                        <li><button type="button" alt="R" label="W" className="keyBtns"> W </button></li>
                        <li><button type="button" alt="E" label="E" className="keyBtns"> E </button></li>
                        <li><button type="button" alt="R" label="R" className="keyBtns"> R </button></li>
                        <li><button type="button" alt="T" label="T" className="keyBtns"> T </button></li>
                        <li><button type="button" alt="Y" label="Y" className="keyBtns"> Y </button></li>
                        <li><button type="button" alt="U" label="U" className="keyBtns"> U </button></li>
                        <li><button type="button" alt="I" label="I" className="keyBtns"> I </button></li>
                        <li><button type="button" alt="O" label="O" className="keyBtns"> O </button></li>
                        <li><button type="button" alt="P" label="P" className="keyBtns"> P </button></li>
                    </ul>
                    <ul className="adjRow3">
                        <li><button type="button" alt="A" label="A" className="keyBtns"> A </button></li>
                        <li><button type="button" alt="S" label="S" className="keyBtns"> S </button></li>
                        <li><button type="button" alt="D" label="D" className="keyBtns"> D </button></li>
                        <li><button type="button" alt="F" label="F" className="keyBtns"> F </button></li>
                        <li><button type="button" alt="G" label="G" className="keyBtns"> G </button></li>
                        <li><button type="button" alt="H" label="H" className="keyBtns"> H </button></li>
                        <li><button type="button" alt="J" label="J" className="keyBtns"> J </button></li>
                        <li><button type="button" alt="K" label="K" className="keyBtns"> K </button></li>
                        <li><button type="button" alt="L" label="L" className="keyBtns"> L </button></li>
                    </ul>
                    <ul className="adjRow4">
                        <li><button type="button" alt="Z" label="Z" className="keyBtns"> Z </button></li>
                        <li><button type="button" alt="X" label="X" className="keyBtns"> X </button></li>
                        <li><button type="button" alt="C" label="C" className="keyBtns"> C </button></li>
                        <li><button type="button" alt="V" label="V" className="keyBtns"> V </button></li>
                        <li><button type="button" alt="B" label="B" className="keyBtns"> B </button></li>
                        <li><button type="button" alt="N" label="N" className="keyBtns"> N </button></li>
                        <li><button type="button" alt="M" label="M" className="keyBtns"> M </button></li>
                        <li><button type="button" alt="Delete" labllabele="backspace" className="keyBtns">
                            <Backspace size={55} strokeWidth={1} color={'gray'} />
                        </button></li>
                    </ul>
                    <ul className="adjRow5">
                        <li><button type="button" alt="enter" label="enter" className="keyBtns returnBtn" onClick={() => fnHideKeyboard()}> CLOSE </button></li>
                        <li><button type="button" alt="Z" label="Z" className="keyBtns spaceBtn"> SPACE </button></li>
                        <li><button type="button" alt="enter" label="enter" className="keyBtns returnBtn"> <b>ENTER</b> </button></li>
                    </ul>
                </div>
            </div>


        </div>
    );
};

export default Generalregistration;